/**
 * Where a rental party was copied from.
 */
export enum RentalPartySourceTypeEnum {
	CUSTOMER = 'customer',
	ACCOUNT = 'account',
}
